import type { Address, Environment } from "../types";
import { CHAIN_REGISTRIES } from "./chains";

export function getFactoryAddress(
  environment: Environment,
  chainId: number,
): Address {
  const chain = CHAIN_REGISTRIES[environment][chainId];
  if (!chain) {
    throw new Error(`Unknown chain ${chainId} for ${environment}`);
  }
  return chain.factoryAddress;
}

export function getWethAddress(
  environment: Environment,
  chainId: number,
): Address {
  const chain = CHAIN_REGISTRIES[environment][chainId];
  if (!chain) {
    throw new Error(`Unknown chain ${chainId} for ${environment}`);
  }
  return chain.wethAddress;
}
